import { BaseProps } from '../../common/BaseProps';
import styles from './FieldGroup.module.css';

interface Props extends BaseProps {
  label: any;
  value: any;
  emptyValue?: string;
  grow2?: boolean;
  size?: string;
  pointer?: boolean;
  valueIcon?: any;
};

const FieldGroup: React.FC<Props> = (props) => {
  const {
    label,
    value,
    emptyValue = '-',
    grow2,
    size = 'sm',
    pointer = false,
    valueIcon,
  } = props;

  const getLabelClass = () => {
    if (size === 'sm') {
      return styles.labelSm;
    }
    return styles.label;
  };
  const getValueClass = () => {
    let styleValues = [''];
    if (pointer) {
      styleValues.push(styles.pointer)
    }

    if (size === 'sm') {
      styleValues.push(styles.valueSm);
      return styleValues.join(" ");
    }

    styleValues.push(styles.value)
    return styleValues.join(" ");
  }

  return (
    <>
      <div className={`${styles.fieldGroup} ${grow2 ? styles.flexGrow2 : ''}`}>
        <span className={getLabelClass()}>{label}</span>
        {!valueIcon && (
          <>
            {value instanceof Array && value.map((v, index) => (
              <div key={index} className={getValueClass()}>{v && v !== '' ? v : emptyValue}</div>
            ))}
            {!(value instanceof Array) && (
              <span className={getValueClass()}>{value && value !== '' ? value : emptyValue}</span>
            )}
          </>
        )}
        {valueIcon && (
          <div className="flex flex-align-center">
            <span className={getValueClass()}>{value && value !== '' ? value : emptyValue}</span>
            <div className={styles.valueIcon}>{props.valueIcon}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default FieldGroup;
